import { JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse, BooleanResponse } from "../base-response";

@JsonConverter
export class FloorPlanConverter implements JsonCustomConvert<FloorPlan> {
  serialize() {}

  deserialize(data: any): FloorPlan {
    const floorPlan = new FloorPlan();
    floorPlan.floorPlanId = data?.floorPlanId ?? data?.floorplanId ?? "";
    floorPlan.projectId = data?.projectId ?? "";
    floorPlan.name = data?.name ?? "";
    floorPlan.svgContent = data?.svgContent ?? "";
    floorPlan.pixelsPerMeter = data?.pixelsPerMeter == null ? null : Number(data.pixelsPerMeter);
    floorPlan.unitsPerMeter = data?.unitsPerMeter == null ? floorPlan.pixelsPerMeter : Number(data.unitsPerMeter);
    floorPlan.createdAt = data?.createdAt ?? "";
    return floorPlan;
  }
}

@JsonConverter
export class FloorPlanArrayConverter implements JsonCustomConvert<Array<FloorPlan>> {
  serialize() {}

  deserialize(data: any): Array<FloorPlan> {
    const converter = new FloorPlanConverter();
    return (data ?? []).map((item: any) => converter.deserialize(item));
  }
}

@JsonConverter
export class FloorPlanCountListConverter implements JsonCustomConvert<FloorPlanCountList> {
  serialize() {}

  deserialize(data: any): FloorPlanCountList {
    const list = new FloorPlanCountList();
    list.count = Number(data?.count ?? 0);
    list.items = new FloorPlanArrayConverter().deserialize(data?.items ?? data?.data ?? []);
    return list;
  }
}

@JsonObject("FloorPlan")
export class FloorPlan {
  @JsonProperty("floorPlanId", String, true)
  floorPlanId: string = "";

  @JsonProperty("projectId", String, true)
  projectId: string = "";

  @JsonProperty("name", String, true)
  name: string = "";

  @JsonProperty("svgContent", String, true)
  svgContent: string = "";

  @JsonProperty("pixelsPerMeter", Number, true)
  pixelsPerMeter: number | null = null;

  unitsPerMeter: number | null = null;

  @JsonProperty("createdAt", String, true)
  createdAt: string = "";
}

@JsonObject("FloorPlanCountList")
export class FloorPlanCountList {
  @JsonProperty("count", Number, true)
  count: number = 0;

  items: Array<FloorPlan> = [];
}

@JsonObject("FloorPlanData")
export class FloorPlanData extends BaseResponse {
  @JsonProperty("data", FloorPlanConverter, true)
  data: FloorPlan = new FloorPlan();
}

@JsonObject("FloorPlanDataArray")
export class FloorPlanDataArray extends BaseResponse {
  @JsonProperty("data", FloorPlanCountListConverter, true)
  data: FloorPlanCountList = new FloorPlanCountList();
}

@JsonObject("FloorPlanCreateResponse")
export class FloorPlanCreateResponse extends BaseResponse {
  @JsonProperty("data", String, true)
  data: string = "";
}

export class FloorPlanScaleResponse extends BooleanResponse {}
